import * as mutationTypes from './mutation-types'
import { keyBy, sortBy } from 'lodash'
import api from '../api'
import { SfLog } from '@app/adapters/logger'

export default {
  state() {
    return {
      workflows: [],
      markingAsRead: false,
    }
  },
  getters: {
    sections: (state) => {
      const defaultWorkflow = []
      const otherWorkflows = []
      for (const wf of state.workflows) {
        const item = {
          categoryId: wf.name,
          categoryName: wf.name,
          expanded: true,
        }
        if (wf.default) {
          defaultWorkflow.push(item)
        } else {
          otherWorkflows.push(item)
        }
      }
      return [].concat(
        defaultWorkflow,
        sortBy(otherWorkflows, 'categoryName'),
        [
          {
            categoryId: 'Report::Template',
            categoryName: window.I18n.t('navigation.reporting'),
            expanded: false,
          },
          {
            categoryId: 'BudgetSet',
            categoryName: window.I18n.t('budget_set.budgets'),
            expanded: false,
          },
          {
            categoryId: 'Document',
            categoryName: window.I18n.t('navigation.permanent'),
            expanded: false,
          },
        ]
      )
    },
    workflowsById: (state) => {
      return keyBy(state.workflows, 'id')
    },
    loadingCommunicationItem: () => false,
  },
  mutations: {
    [mutationTypes.SET_WORKFLOWS](state, workflows) {
      state.workflows = workflows
    },
    [mutationTypes.SET_MARKING_AS_READ](state, markingAsRead) {
      state.markingAsRead = markingAsRead
    },
  },
  actions: {
    async fetchWorkflows({ rootState, commit }) {
      commit(mutationTypes.SET_LOADING, { type: 'workflows', value: true })
      try {
        const result = await api.getWorkflows({
          ledgerId: rootState.ledgerId,
          company_id:
            rootState.companyId ||
            rootState.notifications.activeCompanyId ||
            Silverfin.currentCompanyId,
        })
        commit(mutationTypes.SET_WORKFLOWS, result)
      } catch (error) {
        SfLog.info('Failed to load company workflows', {
          extra: {
            ...window.Silverfin.jsonParams,
            error,
          },
        })
      } finally {
        commit(mutationTypes.SET_LOADING, { type: 'workflows', value: false })
      }
    },
  },
}
